import React, {FC} from 'react';
import {Header} from "./Header";

export const TextContainer: FC<any> = (props) => {
    return (
        <div className="text-white w-full h-screen flex flex-col">
            <div className="mx-5">
                <Header/>
                <div className="flex justify-center">
                    <div className="max-w-[1240px] border-white border-y my-8 py-8 w-full">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
};
